var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_14444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 3.33203H4.66668C4.31305 3.33203 3.97392 3.47251 3.72387 3.72256C3.47382 3.9726 3.33334 4.31174 3.33334 4.66536V12.6654C3.33334 13.019 3.47382 13.3581 3.72387 13.6082C3.97392 13.8582 4.31305 13.9987 4.66668 13.9987H11.3333C11.687 13.9987 12.0261 13.8582 12.2762 13.6082C12.5262 13.3581 12.6667 13.019 12.6667 12.6654V4.66536C12.6667 4.31174 12.5262 3.9726 12.2762 3.72256C12.0261 3.47251 11.687 3.33203 11.3333 3.33203H10",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.33333C6 2.97971 6.14048 2.64057 6.39052 2.39052C6.64057 2.14048 6.97971 2 7.33333 2H8.66667C9.02029 2 9.35943 2.14048 9.60948 2.39052C9.85952 2.64057 10 2.97971 10 3.33333C10 3.68696 9.85952 4.02609 9.60948 4.27614C9.35943 4.52619 9.02029 4.66667 8.66667 4.66667H7.33333C6.97971 4.66667 6.64057 4.52619 6.39052 4.27614C6.14048 4.02609 6 3.68696 6 3.33333Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33332 7.33203H7.66666C7.40144 7.33203 7.14709 7.43739 6.95955 7.62492C6.77201 7.81246 6.66666 8.06681 6.66666 8.33203C6.66666 8.59725 6.77201 8.8516 6.95955 9.03914C7.14709 9.22667 7.40144 9.33203 7.66666 9.33203H8.33332C8.59854 9.33203 8.85289 9.43739 9.04043 9.62492C9.22797 9.81246 9.33332 10.0668 9.33332 10.332C9.33332 10.5972 9.22797 10.8516 9.04043 11.0391C8.85289 11.2267 8.59854 11.332 8.33332 11.332H6.66666",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3346V12.0013M8 6.66797V7.33464",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_14444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon10);
export default __webpack_public_path__ + "static/media/dashboard-icon-10.2f9ff775d76756f41a96d9973a8d8cda.svg";
export { ForwardRef as ReactComponent };